<div class="landing-page-main" [ngClass]="{ 'stop-scroll': displayRequestAuthority }">
  <div class="landing-page-blocking" [hidden]="!blocked">
    <span>Loading...</span>
  </div>
  <div class="landing-page-legend">
    <div class="left-element page-title">
      <span>{{ title }}</span>
    </div>
    <div class="left-element location-tracker"></div>
    <div class="right-element legend">
      <div class="legend-entry legend-label">
        <span>Legend:</span>
      </div>
      <div class="legend-group open-authorities" *ngIf="selectedFilterStatus === FilterStatus.OPEN">
        <div class="legend-entry request-submitted">
          <i class="csx-arrows_spot_1"></i>
          <span>Request Submitted</span>
        </div>
        <div class="legend-entry pending">
          <i class="csx-common_in_progress"></i>
          <span>Pending</span>
        </div>
        <div class="legend-entry approved">
          <i class="csx-common_approve"></i>
          <span>Approved</span>
        </div>
        <div class="legend-entry active">
          <i class="csx-common_check"></i>
          <span>Active</span>
        </div>
      </div>
      <div class="legend-group released-authorities" *ngIf="selectedFilterStatus === FilterStatus.RELEASED">
        <div class="legend-entry released">
          <i class="csx-arrows_deallocate"></i>
          <span>Released</span>
        </div>
      </div>
      <div class="legend-group cancelled-authorities" *ngIf="selectedFilterStatus === FilterStatus.CANCELLED">
        <div class="legend-entry cancelled">
          <i class="csx-common_ban"></i>
          <span>Cancelled</span>
        </div>
        <div class="legend-entry error">
          <i class="csx-common_delete"></i>
          <span>Error</span>
        </div>
      </div>
      <div class="legend-group rejected-authorities" *ngIf="selectedFilterStatus === FilterStatus.REJECTED">
        <div class="legend-entry rejected">
          <i class="csx-common_alert"></i>
          <span>Rejected</span>
        </div>
      </div>
    </div>
  </div>
  <div class="lading-page-content">
    <div class="landing-page-actions">
      <div class="action-group-left">
        <p-selectButton class="authority-filter" [options]="filterStatusList" [(ngModel)]="selectedFilterStatus"
          (onOptionClick)="updateQueryParam($event)">
        </p-selectButton>
      </div>
      <div class="action-group-right">
        <button type="button" pButton class="action-button-group" label="Request Authority"
          (click)="openRequestAuthorityDialog(null)" [disabled]="!systemState.state || isAdmin()"></button>
      </div>
    </div>
    <div class="landing-page-table">
      <div class="atm-table-table">
        <div class="table-column-status-wrapper column-status">
          <span>Status</span>
        </div>
        <div class="table-head">
          <div class="table-column column-ec1number">
            <span>EC-1 #</span>
          </div>
          <div class="table-column column-line">
            <span>Line</span>
          </div>
          <div class="table-column column-operate-on">
            <span>Operate On</span>
          </div>
          <div class="table-column column-from">
            <span>Operating From</span>
          </div>
          <div class="table-column column-to">
            <span>Operating To</span>
          </div>
          <div class="table-column column-direction">
            <span>Direction</span>
          </div>
          <div class="table-column column-dated">
            <span>Time/Date</span>
          </div>
          <div class="table-column column-actions">
            <span></span>
          </div>
        </div>
        <div class="table-body">
          <div class="table-row"
            *ngFor="let entry of authorities | authorityFilter: selectedFilterStatus; let i = index" [ngClass]="{
              'last-active':
                entry.displayStatus === DisplayStatus.ACTIVE &&
                i < authorities.length - 1 &&
                authorities[i + 1].displayStatus !== DisplayStatus.ACTIVE
            }">
            <authority-row [authority]="entry" [authorityMenu]="entry.authorityMenu"
              [isSharedModificationRejected]="entry.isSharedModificationRejected"
              (copyAndResubmit)="openRequestAuthorityDialog(entry)"
              (actionRequested)="openUserConfirmationDialog(entry, $event)"
              (commentAuthority)="createCommentRequest($event)" (changeRequest)="createChangeRequest($event)"
              [lastUpdated]="lastUpdated" [systemStateStatus]="systemState.state"></authority-row>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<authority-dialog [display]="displayRequestAuthority" [authority]="authorityForCopyAndResubmit"
  (onCloseDialog)="closeDialog($event)"></authority-dialog>
<user-confirmation-dialog [authority]="authorityForUserConfirmation" [action]="actionForUserConfirmation"
  (userAccept)="userAccepted($event)" (userCancel)="userCancelled($event)"></user-confirmation-dialog>
<comment-dialog [authority]="authorityForComment" (onClose)="onCloseCommentDialog()"></comment-dialog>
<change-request [authority]="authorityForChangeRequest" (onClose)="onCloseChangeRequest()"
  (onCloseDialog)="onCloseChangeRequest()" (onCancelShareModification)="showCloseModal($event)"></change-request>
<confirmation-dialog *ngIf="showConfirmation" [showConfirmation]="showConfirmation"
  (confirmationAccept)="confirmationAccepted()" (confirmationCancel)="confirmationCancelled()"
  [showReason]="false" [showRejectReason]="false" [data]="confirmationDialogData"></confirmation-dialog>